import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSortUpAndDown = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1751 8.32953L10.8458 10.6588L9.29297 9.10596L12.3987 6.00023C12.8275 5.57142 13.5227 5.57142 13.9516 6.00023L17.0573 9.10596L15.5044 10.6588L13.1751 8.32953Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1751 18.0235L10.8458 15.6942L9.29297 17.2471L12.3987 20.3528C12.8275 20.7816 13.5227 20.7816 13.9516 20.3528L17.0573 17.2471L15.5044 15.6942L13.1751 18.0235Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);
